import { useTenant } from '../../context/TenantContext.jsx';
import { ProductCardSlot } from '../../registry/slots/ProductCardSlot.jsx';

export function ProductCard({
  product,
  onViewProduct,
  onAddToCart,
  onInquiry,
  compact = false,
  variant,
  index = 0,
  ...props
}) {
  let tenant = null;
  try {
    const ctx = useTenant();
    tenant = ctx?.tenant || null;
  } catch {}

  return (
    <ProductCardSlot
      variant={variant || tenant?.settings?.product_card_variant}
      product={product}
      tenant={tenant}
      onViewProduct={onViewProduct}
      onAddToCart={onAddToCart}
      onInquiry={onInquiry}
      compact={compact}
      index={index}
      {...props}
    />
  );
}
